<template>
    <b-navbar class="nav-bar fixed-top" toggleable="lg" type="light">
        <b-navbar-brand href="#">
            <img src="~@/assets/checkout/koa-logo.svg" height="65px"/>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="ml-auto">
                <div class="d-flex align-items-center mr-4 icon-class">
                    <img src="~@/assets/checkout/shopping-bag-icon.svg"/>
                    <span class="badge badge-light">2</span>
                </div>
                <div class="d-flex align-items-center">
                    <img src="~@/assets/checkout/lang-icon.svg"/>
                    <p class="my-auto ml-1 checkout-font">ENG</p>
                </div>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
import { BCollapse, BNavbar, BNavbarBrand, BNavbarNav, BNavbarToggle } from 'bootstrap-vue';

export default {
    name: 'DynamicCheckoutNav',
    components: {
        BNavbar,
        BNavbarBrand,
        BNavbarToggle,
        BCollapse,
        BNavbarNav
    }
}
</script>

<style scoped>
    .nav-bar {
        font-family: "OpenSans";
        background-color: #ffffff;
        border: 1px solid #D8D8D8;
    }

    .icon-class{
        position: relative;
    }
    .icon-class span{
        position: absolute;
        top: 3px;
        right: -4px;
        display: block;
        background-color: #FF6E88;
        border-radius: 50%;
        color: #ffffff;
        font-size: 0.6rem;
    }
    .icon-class .span-badge{
        position: absolute;
        top: 15px;
        right: 5px;
        font-size: 0.5rem;
        display: block;
        color: #ffffff;
        border-radius: 50%;
        background-color: #FF6E88;
    }

    .nav-text {
        font-size: 1.3rem;
    }
</style>